import styles from "./ToS.module.css";
import commonStyles from "./../../Common.module.css";
import React from "react";

function Tos() {
  return (
    <div className={styles["Tos"]}>
            <div className={commonStyles["cateTitle"]}>
                <h1>이용약관</h1>
            </div>
            <hr />

            <div className={styles["scrollBox"]}>
                <p>
                    <h3>제1조</h3>
                    <p>
                        1&#41; Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perferendis nostrum eius recusandae hic
                        inventore similique. Vitae adipisci repudiandae eum fugiat impedit, recusandae asperiores expedita vel
                        tempora libero assumenda fuga architecto.
                    </p>
                    <p>
                        2&#41; Lorem ipsum dolor sit, amet consectetur adipisicing elit. Commodi repudiandae architecto id nam
                        debitis dolores unde voluptates? Eum autem adipisci ratione aliquam, explicabo ipsa! Ducimus omnis earum
                        asperiores sit similique!
                    </p>
                    <p>
                        3&#41; Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla voluptas, ex recusandae a vel
                        ratione consequuntur odio aliquid, magnam quis voluptate incidunt quia ut reiciendis repellendus
                        quisquam, exercitationem esse quod.
                    </p>
                </p>
                <br />

                <p>
                    <h3>제2조</h3>
                    <p>
                        1&#41; Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perferendis nostrum eius recusandae hic
                        inventore similique. Vitae adipisci repudiandae eum fugiat impedit, recusandae asperiores expedita vel
                        tempora libero assumenda fuga architecto.
                    </p>
                    <p>
                        2&#41; Lorem ipsum dolor sit, amet consectetur adipisicing elit. Commodi repudiandae architecto id nam
                        debitis dolores unde voluptates? Eum autem adipisci ratione aliquam, explicabo ipsa! Ducimus omnis earum
                        asperiores sit similique!
                    </p>
                    <p>
                        3&#41; Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla voluptas, ex recusandae a vel
                        ratione consequuntur odio aliquid, magnam quis voluptate incidunt quia ut reiciendis repellendus
                        quisquam, exercitationem esse quod.
                    </p>
                </p>
                <br />

                <p>
                    <h3>제3조</h3>
                    <p>
                        1&#41; Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perferendis nostrum eius recusandae hic
                        inventore similique. Vitae adipisci repudiandae eum fugiat impedit, recusandae asperiores expedita vel
                        tempora libero assumenda fuga architecto.
                    </p>
                    <p>
                        2&#41; Lorem ipsum dolor sit, amet consectetur adipisicing elit. Commodi repudiandae architecto id nam
                        debitis dolores unde voluptates? Eum autem adipisci ratione aliquam, explicabo ipsa! Ducimus omnis earum
                        asperiores sit similique!
                    </p>
                    <p>
                        3&#41; Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla voluptas, ex recusandae a vel
                        ratione consequuntur odio aliquid, magnam quis voluptate incidunt quia ut reiciendis repellendus
                        quisquam, exercitationem esse quod.
                    </p>
                </p>
                <br />

                <p>
                    <h3>제4조</h3>
                    <p>
                        1&#41; Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perferendis nostrum eius recusandae hic
                        inventore similique. Vitae adipisci repudiandae eum fugiat impedit, recusandae asperiores expedita vel
                        tempora libero assumenda fuga architecto.
                    </p>
                    <p>
                        2&#41; Lorem ipsum dolor sit, amet consectetur adipisicing elit. Commodi repudiandae architecto id nam
                        debitis dolores unde voluptates? Eum autem adipisci ratione aliquam, explicabo ipsa! Ducimus omnis earum
                        asperiores sit similique!
                    </p>
                    <p>
                        3&#41; Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla voluptas, ex recusandae a vel
                        ratione consequuntur odio aliquid, magnam quis voluptate incidunt quia ut reiciendis repellendus
                        quisquam, exercitationem esse quod.
                    </p>
                </p>
                <br />

                <p>
                    <h3>제5조</h3>
                    <p>
                        1&#41; Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perferendis nostrum eius recusandae hic
                        inventore similique. Vitae adipisci repudiandae eum fugiat impedit, recusandae asperiores expedita vel
                        tempora libero assumenda fuga architecto.
                    </p>
                    <p>
                        2&#41; Lorem ipsum dolor sit, amet consectetur adipisicing elit. Commodi repudiandae architecto id nam
                        debitis dolores unde voluptates? Eum autem adipisci ratione aliquam, explicabo ipsa! Ducimus omnis earum
                        asperiores sit similique!
                    </p>
                    <p>
                        3&#41; Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla voluptas, ex recusandae a vel
                        ratione consequuntur odio aliquid, magnam quis voluptate incidunt quia ut reiciendis repellendus
                        quisquam, exercitationem esse quod.
                    </p>
                </p>
                <br />

                <p>
                    <h3>제6조</h3>
                    <p>
                        1&#41; Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perferendis nostrum eius recusandae hic
                        inventore similique. Vitae adipisci repudiandae eum fugiat impedit, recusandae asperiores expedita vel
                        tempora libero assumenda fuga architecto.
                    </p>
                    <p>
                        2&#41; Lorem ipsum dolor sit, amet consectetur adipisicing elit. Commodi repudiandae architecto id nam
                        debitis dolores unde voluptates? Eum autem adipisci ratione aliquam, explicabo ipsa! Ducimus omnis earum
                        asperiores sit similique!
                    </p>
                    <p>
                        3&#41; Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla voluptas, ex recusandae a vel
                        ratione consequuntur odio aliquid, magnam quis voluptate incidunt quia ut reiciendis repellendus
                        quisquam, exercitationem esse quod.
                    </p>
                </p>
                <br />

                <p>
                    <h3>제7조</h3>
                    <p>
                        1&#41; Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perferendis nostrum eius recusandae hic
                        inventore similique. Vitae adipisci repudiandae eum fugiat impedit, recusandae asperiores expedita vel
                        tempora libero assumenda fuga architecto.
                    </p>
                    <p>
                        2&#41; Lorem ipsum dolor sit, amet consectetur adipisicing elit. Commodi repudiandae architecto id nam
                        debitis dolores unde voluptates? Eum autem adipisci ratione aliquam, explicabo ipsa! Ducimus omnis earum
                        asperiores sit similique!
                    </p>
                    <p>
                        3&#41; Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla voluptas, ex recusandae a vel
                        ratione consequuntur odio aliquid, magnam quis voluptate incidunt quia ut reiciendis repellendus
                        quisquam, exercitationem esse quod.
                    </p>
                </p>
            </div>
        </div>);

}

export default Tos;